import React, { useState, useEffect } from "react";
import { Card, Form, Input, Button, message, Divider } from "antd";
import { useSelector } from "react-redux";
import axios from "axios";
import appConfig from "../../utils/config";

const Plugins = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    
    // Auth token is stored as accessToken in redux authReducer
    const { accessToken } = useSelector((state) => state.auth);
    const token = accessToken || localStorage.getItem("accessToken");

    useEffect(() => {
        const fetchConfig = async () => {
            if (!token) return;
            try {
                const response = await axios.get(`${appConfig.apiURL}/v2/plugins/config`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                
                if (response.data?.status) {
                    const data = response.data.results;
                    form.setFieldsValue({
                        cf_account_id: data.cloudflare_account_id || "",
                        cf_api_token: data.cloudflare_api_token || ""
                    });
                }
            } catch (err) {
                console.error("Failed to fetch plugin config", err);
                message.error("Could not load existing plugin settings.");
            }
        };
        fetchConfig();
    }, [form, token]);

    const onFinish = async (values) => {
        if (!token) {
            message.error("You must be logged in to save settings.");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                cloudflare_account_id: values.cf_account_id || "",
                cloudflare_api_token: values.cf_api_token || ""
            };

            const response = await axios.post(`${appConfig.apiURL}/v2/plugins/config`, payload, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (response.data?.status) {
                message.success("Plugin settings saved successfully!");
            } else {
                message.error("Failed to save settings.");
            }
        } catch (error) {
            console.error("Save config error", error);
            message.error(error.response?.data?.message || "An error occurred while saving.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Plugins Settings</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Dashboard</a></li>
                                <li className="breadcrumb-item active">Plugins</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-8 col-lg-6">
                        <Card title={<><i className="fa fa-plug mr-2"></i> Cloudflare AI Generator</>} className="mb-4">
                            <p className="text-muted mb-4">
                                Configure your Cloudflare REST API credentials here. These are stored locally in your browser.
                            </p>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onFinish}
                            >
                                <Form.Item
                                    label="Cloudflare Account ID"
                                    name="cf_account_id"
                                    rules={[{ required: true, message: "Please input your Cloudflare Account ID!" }]}
                                >
                                    <Input placeholder="Enter your Account ID" />
                                </Form.Item>

                                <Form.Item
                                    label="Cloudflare API Token"
                                    name="cf_api_token"
                                    rules={[{ required: true, message: "Please input your Cloudflare API Token!" }]}
                                >
                                    <Input.Password placeholder="Enter your API Token" />
                                </Form.Item>

                                <Divider />
                                
                                <Form.Item className="mb-0">
                                    <Button type="primary" htmlType="submit" loading={loading}>
                                        Save Settings
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Plugins;
